import MatchyGame from '../../images/MatchyGame.png'
import DocMcOffice from '../../images/DocMcOffice.png'
import Streamin from '../../images/Streamin-Screenshots.png'
import OldPersonalPortfolio from '../../images/OLDPersonalPortfolio.png'
const otherworksdata =[
    {
        title: "Doc McOffice",
        skills: "Express | Node| MongoDB | Tailwind CSS",
        description:
          "Full Stack Doctor Appointment Tracker application that allows users to use full CRUD capabilities to store patient's doctor appointments",
        image: DocMcOffice,
        imageAlt:"DocMcOffice",
        githubLink: "https://github.com/rbidon/DocMcOffice",
        deployLink:"https://docmcoffice.herokuapp.com/"
       
    },{
        title: "OLD Personal Portfolio",
        skills: "HTML | JavaScript | Bootstrap| CSS",
        description:
          "Old Personal Personal Portfolio, used JavaScript and CSS",
        image: OldPersonalPortfolio,
        imageAlt:"OLD Personal Portfolio",
        wireframeLink:"https://www.figma.com/file/jz3YeBL3LAkdh2wdrdFFuD/Portifolo?node-id=0%3A1&t=bPqmExMluSBI7t8e-1",
        githubLink: "https://github.com/rbidon/portfolio_project",
        deployLink: "https://roussevbidon.com/"
    },{
    // },{
    //     title: "Personal Portfolio",
    //     skills: "React | Tailwind CSS",
    //     description:
    //       "Personal Personal Portfolio, used React and TailWindCSS",
    //     image: "Personal Portfolio Image",
    //     imageAlt:"Personl Portfolio",
    //     wireframeLink:"https://www.figma.com/file/jz3YeBL3LAkdh2wdrdFFuD/Portifolo?node-id=0%3A1&t=bPqmExMluSBI7t8e-1",
    //     githubLink: "https://github.com/rbidon/react_portifolo"
    // },{
        title: "Matchy Game",
        skills: " HTML | JavaScript | CSS",
        description:
          " Two Player Matching Game that has users create",
        image: MatchyGame,
        imageAlt:"Matchy Game Photo",
        wireframeLink:"https://www.figma.com/file/hnNus3wYFm4CGsplWfH2h3/Matchy-Game-Wireframe?node-id=0%3A1&t=XdHDDRQFCp9GR0Gz-1",
        githubLink: "https://github.com/rbidon/Matchy",
        deployLink:"https://rbidon.github.io/Matchy/"
    },{
        title: "Streamin",
        skills: "MERN Stack",
        description:
          "A social media application created with two other developers gives users the ability to CRUD their own videos and retrieve other users videos",
        image: Streamin,
        imageAlt:"Streamin Game Photo",
        wireframeLink:"https://www.figma.com/file/GjALwdHH6jhqC3E2UzJQ6P/Streamin-Wireframe?node-id=0%3A1&t=RS95A3uQRpoNl3iJ-1",
        githubLink: "https://github.com/Bernard-Calma/streamin-frontend",
        deployLink:"https://stream-in.herokuapp.com/"
    },
    
]


export default otherworksdata